module.exports = {
    // SearchBarExt
    'Объекты': 'Объекты',
    'Адрес': 'Адрес',
    'По вашему запросу ничего не найдено': 'По вашему запросу ничего не найдено',
    'Произошла ошибка на стороне сервера': 'Произошла ошибка на стороне сервера',
    'Слой карты': 'Слой карты',
    // Measurement
    'км<sup>2</sup>': 'км<sup>2</sup>',
    'м<sup>2</sup>': 'м<sup>2</sup>',
    'км': 'км',
    'м': 'м',
    // ChartLegend
    'Другие': 'Другие',
    // Balloon
    'Закрыть': 'Закрыть',
    // BaseLayer
    'Участники OpenStreetMap': 'Участники OpenStreetMap',
    'Спутник': 'Спутник',
    'Ростелеком': 'Ростелеком',
    'Сменить формат координат': 'Сменить формат координат'
};


//////////////////
// WEBPACK FOOTER
// ./src/View/i18n/ru.js
// module id = 241
// module chunks = 0